import React from 'react';
import { Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faXmark } from '@fortawesome/free-solid-svg-icons';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../../../Components/ButtonCustom';
import { Warning } from '../../../../../../../../../../../../../../../../Components/CustomUi/warning';

interface PropsModal {
    abrir: boolean;
    abaAtual: string;
    setAbrir: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmado: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalConfirmar: React.FC<PropsModal> = ({ abrir, abaAtual, setAbrir, setConfirmado }) => {

    return (
        <Modal style={{ left: '70px' }} open={abrir} footer={null} closeIcon={false} zIndex={9999}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <Warning type='warning'>
                    {abaAtual === 'Pontos' ? "Ao voltar você perderá todos os pontos adicionados e movidos! Deseja voltar?" : "Ao voltar você perderá a ordenação dos pontos! Deseja voltar?"}
                </Warning>

                <div style={{ display: 'flex', gap: 10 }}>
                    <ButtonCustom danger type='secondary' onClick={() => setAbrir(false)} icon={<FontAwesomeIcon icon={faXmark} />}>Cancelar</ButtonCustom>
                    <ButtonCustom onClick={() => setConfirmado(true)} icon={<FontAwesomeIcon icon={faArrowAltCircleLeft} />} >Voltar</ButtonCustom>
                </div>
            </div>
        </Modal>
    )
}

export default ModalConfirmar;